"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutUsPreview() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="o-nas-zapowiedź" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div ref={imageRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="relative aspect-[4/3] rounded-md overflow-hidden shadow-medium">
              <img src="https://ample-sailfish.10web.cloud/wp-content/uploads/2026/02/odszkodowanie-zadoscuczynienie-wypadek-poslizgniecie-upadek-szkodaOsobowa-prawoOdszkodowan-odszkodowanieZaWypadek-wypadekWmiejscuPublicznym-odpowiedzialnoscCywilnaslupsk.png" alt="Biuro prawne Odszkodowania Słupsk - profesjonalna konsultacja prawna" className="w-full object-cover !h-auto" />
            </div>
          </div>

          {}
          <div ref={textRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${textVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <h2 className="text-3xl md:text-4xl font-display font-semibold tracking-tight mb-6 text-foreground">
              Pomoc prawna w sprawach odszkodowawczych
            </h2>
            <p className="text-lg md:text-xl leading-relaxed text-muted-foreground mb-6">
              Zgłaszają się do nas osoby, które brały udział w wypadku, doznały
              szkody osobowej lub straciły osobę bliską i nie wiedzą, jakie
              roszczenia im przysługują. Każdą sprawę analizujemy indywidualnie,
              oceniając odpowiedzialność sprawcy oraz podstawy prawne dochodzenia
              świadczeń.
            </p>
            <p className="text-lg md:text-xl leading-relaxed text-muted-foreground mb-8">
              Zapewniamy obsługę prawną na etapie przedsądowym oraz sądowym.
              Możliwa jest współpraca zdalna oraz kontakt osobisty na terenie
              Słupska.
            </p>
            <Link to="/AboutUsPage">
              <Button className="btn-primary transition-all duration-[var(--duration-fast)] hover:shadow-medium hover:-translate-y-0.5" size="lg">
                Dowiedz się więcej
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}